/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Grid, ProductCard, Tag, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

const styles = {
  container: css`
    .cds-ProductCard-base {
      max-width: 100% !important;
    }

    .cds-ProductCard-content {
      display: grid !important;
    }

    .cds-ProductCard-content > div:nth-child(1),
    .cds-ProductCard-content > div:nth-child(2) {
      flex: 1;
    }

    .cds-ProductCard-content > div:nth-child(3) {
      flex-basis: 100%;
    }

    .cds-ProductCard-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .cds-ProductCard-content > div:nth-child(1) {
      grid-row: 1 / 2;
      grid-column: 1 / 2;
    }

    .cds-ProductCard-content > div:nth-child(2) {
      grid-row: 2 / 3;
      grid-column: 1 / 2;
    }

    .cds-ProductCard-content > div:nth-child(3) {
      grid-row: 1 / 3;
      grid-column: 2 / 3;
      justify-self: end;
      align-self: center;
    }
  `,
};

type Props = {
  title: string;
  partners: {
    logoUrl: string;
    name: string;
  }[];
  toolsAndLanguages: string[];
  timeDuration: number;
  linkProps: string;
};

const SkillPathwayModuleV2 = ({ title, partners, toolsAndLanguages, timeDuration, linkProps }: Props) => {
  return (
    <div css={styles.container}>
      <ProductCard
        variant="grid"
        title={{
          name: title,
          linkProps: {
            href: linkProps,
          },
        }}
        partners={partners.length > 0 ? partners : undefined}
        productType="Course"
        body={
          <Typography2 variant="bodySecondary" component="p" color="supportText">
            <FormattedMessage
              message={_t('{timeDuration, plural, =1 {# hour} other {# hours}}')}
              timeDuration={timeDuration}
            />
          </Typography2>
        }
        footer={
          <Grid container spacing={4}>
            {toolsAndLanguages.map((skill) => {
              return (
                <Grid item key={skill}>
                  <Tag>{skill}</Tag>
                </Grid>
              );
            })}
          </Grid>
        }
      />
    </div>
  );
};

export default SkillPathwayModuleV2;
